/* ---------------------------------------------------------------------------
   STL 2026 — 4.3  keep the `Size : X` row in step with the selection

   WHY THIS FILE EXISTS, because the Liquid used to claim it did not need to.

   `global.js` has `updatePickerInnerHtml()`, which replaces the whole variant
   picker with freshly fetched server HTML — and if that ran on every variant
   change the Liquid would re-render with the new selection for free. It does not.
   The call sits inside `if (this.isHighVariantNeedUpdate)`, the branch for
   products with more variants than Liquid can inline. Staple's products have six,
   so the branch never fires and the picker is never re-rendered: the size name and
   the stock state were both baked in at page load and stayed there.

   Madrid does still fetch on variant change, but for a non-high-variant product
   `setCurrentVariantAfterFetch()` only swaps the `[data-selected-variant]` JSON
   blob — not the markup.

   So this reads what is already in the DOM rather than adding a second fetch:
   the checked radio carries the size in `value`, `.disabled` for sold out, and
   `data-stl-low-stock` for a single unit left (emitted by
   product-variant-options.liquid).
   ------------------------------------------------------------------------- */

(function () {
  'use strict';

  var SIZE_INPUT = "input[name^='SIZE' i]";

  /* Wording must match the Liquid exactly, or the row would flicker between two
     spellings of the same state as you click around. */
  function stateFor(input) {
    if (input.classList.contains('disabled')) return 'Out of Stock';
    if (input.hasAttribute('data-stl-low-stock')) return 'Low In Stock';
    return '';
  }

  function sync(input) {
    var fieldset = input.closest('.product-form__controls');
    if (!fieldset) return;

    var label = fieldset.querySelector('.stl-size-label');
    if (!label) return;

    /* Keep whatever prefix the Liquid produced ("Size") rather than hardcoding
       it — the option name is `option.name | downcase | capitalize`, and this
       catalogue's option is uppercase SIZE, which could change. */
    var name = label.querySelector('.stl-size-label__name');
    if (name) {
      var prefix = name.textContent.split(' : ')[0].trim();
      name.textContent = prefix + ' : ' + input.value;
    }

    /* The state span is only rendered by the Liquid when there IS a state, so it
       has to be created and removed rather than just re-filled. */
    var state = stateFor(input);
    var stateEl = label.querySelector('.stl-size-label__state');

    if (state) {
      if (!stateEl) {
        stateEl = document.createElement('span');
        stateEl.className = 'stl-size-label__state';
        label.appendChild(stateEl);
      }
      stateEl.textContent = state;
    } else if (stateEl) {
      stateEl.remove();
    }
  }

  /* Delegated on document so it survives Madrid replacing the picker in the
     quick-add sheet and quick view, where the markup IS re-rendered. */
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches || !target.matches(SIZE_INPUT)) return;
    sync(target);
  });
})();
